import urls from './urls';
import axios, { AxiosResponse } from 'axios';
import { addParamsToQueryString } from '../functions/utils';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';

interface TravelPlanParams {
  UserTravelProfileID?: string;
  [key: string]: any;
}

class TravelPlanApi {
  static getUserTravel(): Promise<IApiResponse> {
    const url = urls.USER_TRAVEL;
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postUserTravel(params: any): Promise<IApiResponse> {
    const url = urls.USER_TRAVEL_SEARCH;
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateTravelPlan(params: TravelPlanParams): Promise<IApiResponse> {
    const url = urls.CREATE_TRAVEL_PLAN;
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchUpdateTravelPlan(params: TravelPlanParams): Promise<IApiResponse> {
    const url = urls.UPDATE_TRAVEL_PLAN.replace('{ID}', params.UserTravelProfileID || '');
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getMyTravelPlan(params: any): Promise<IApiResponse> {
    const url = addParamsToQueryString(urls.GET_MY_TRAVEL_PLAN, params);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchDeleteTravelPlan(listId: string[] | number[]): Promise<IApiResponse> {
    const url = urls.DELETE_TRAVEL_PLAN;
    const body = { ListID: listId };
    return axios.patch(url, body, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
}

export default TravelPlanApi;
